<mat-sidenav-container class="sidenav-container" *transloco="let t;">
    <mat-sidenav #sidenav mode="over" opened="false" class="sidenav" [fixedInViewport]="true" [fixedBottomGap]="10">
        <mat-toolbar>
            <mat-toolbar-row>
                <span class="example-spacer">{{t('about.content')}}</span>
                <span>
                  <mat-icon
                    (click)="sidenav.close()"
                    clase="toolbar-icon"
                    aria-hidden="false"
                    aria-label="close"
                    >close
                  </mat-icon>
                </span>
            </mat-toolbar-row>
        </mat-toolbar>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
            <div fxFlex="100" fxLayout="row" [routerLink]="[ '/']" (click)="sidenav.close()" fxLayoutAlign="start center" class="padding-10 sidenav-label">
                <span>
                <mat-icon   aria-label="close">home</mat-icon>
                </span>
                <span class="padding-left-right-5">{{ t('Sidenav.Home')}}</span>
            </div>
            <div fxFlex="100" fxLayout="row" [routerLink]="[ '/user']" (click)="sidenav.close()" fxLayoutAlign="start center" class="padding-10 sidenav-label cursur-pointer">
                <mat-icon aria-label="close">perm_identity </mat-icon>
                <span class="padding-left-right-5"> {{ t('Sidenav.User Management')}}</span>
            </div>
            <div fxFlex="100" fxLayout="row" [routerLink]="[ '/']" (click)="sidenav.close()" fxLayoutAlign="start center" class="padding-10 sidenav-label cursur-pointer">
                <mat-icon aria-label="close">location_on </mat-icon>
                <span class="padding-left-right-5"> {{ t('Sidenav.Site Management')}}</span>
            </div>
            <div fxFlex="100" fxLayout="row" [routerLink]="[ '/']" (click)="sidenav.close()" fxLayoutAlign="start center" class="padding-10 sidenav-label cursur-pointer">
                <mat-icon aria-label="close">contact_support
                </mat-icon>
                <span>{{ t('Sidenav.Support')}}</span>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content fxLayout="column">
        <div fxLayout="column" fxFlex>
            <div fxFlex="initial">
                <app-site-navbar></app-site-navbar>
            </div>
            <div fxFlex fxLayout="column" style="overflow: auto;">
                <div class="loader-parentelement">
                    <ngx-loading-bar height="3px" color="#ea7600" [includeSpinner]="false"></ngx-loading-bar>
                </div>
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
